import { Col, InputField, Label, PrimaryButton, ReactSelectBox, SwitchToggle } from 'client/CommonComponents';
import './Growth.scss'
import { CONSTANTS } from "client/utils/constants";

const Growth = (props: any) => {

  const employeeBusiness = props.employeeBusiness;
  const reason = props.reason;
  const onClickGrowthNewEmployeeOrBusiness = props.onClickGrowthNewEmployeeOrBusiness;
  const onClickGrowthEmployeeId = props.onClickGrowthEmployeeId;
  const onClickGrowthEmployeeName = props.onClickGrowthEmployeeName;
  const onClickGrowthSalesAmount = props.onClickGrowthSalesAmount;
  const onClickGrowthComments = props.onClickGrowthComments;
  
  const salesAmountFormat = props.salesAmountFormat;
  const requestType = props.requestType;
  const onChangeQuotePrice = props.onChangeQuotePrice;
  const onChangeNewEmployee = props.onChangeNewEmployee;
  const onClickValidateEmployeeInfo = props.onClickValidateEmployeeInfo
  const setEmployeeFieldDisable = props?.setEmployeeFieldDisable
  const OnBlurOfFields = props?.OnBlurOfFields

 const isRequiredEmpJob = (reasonTemp:any) => {
  return reasonTemp.newEmployeeBusiness != CONSTANTS.NEW_EMPLOYEE || !reasonTemp.showNewEmployee
 }
  return (<>
    {(reason.requestType === CONSTANTS.NON_STANDARD_EQUIPMENT || reason.requestType === CONSTANTS.MANAGED_EQUIPMENT) && <Col xs={12} sm={4} md={4} lg={4} className='mt-0 mb-3'>
      <Label required data-attribute="Growth_Default_Label">New Employee/Business</Label>
      <ReactSelectBox
        options={employeeBusiness}
        onChange={(item: any) => onClickGrowthNewEmployeeOrBusiness(item, reason)}
        name={reason.newEmployeeBusiness}
        value={reason.newEmployeeBusiness == "" ? { label: "Select New Employee/Business", text: "" } : { label: reason.newEmployeeBusiness, text: reason.newEmployeeBusiness }}
        className={reason.newEmployeeBusinessError ? 'controlValidation' : ''}
       data-attribute="Growth_newEmployeeBusiness_SearchSelectBox" />
      {reason.newEmployeeBusinessError ? <p className='validMessage'>{reason.newEmployeeBusinessError}</p> : null}
    </Col>}
    {reason.newEmployeeBusiness !== undefined && reason.newEmployeeBusiness !== "Select New Employee/Business" && reason.newEmployeeBusiness !== "" && <>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label required={isRequiredEmpJob(reason)} data-attribute="Growth_Default_Label_2">{reason.newEmployeeBusiness == CONSTANTS.NEW_EMPLOYEE ? CONSTANTS.EMP_ID : CONSTANTS.JOB_ID}</Label>
        <InputField
          placeholder={reason.newEmployeeBusiness === CONSTANTS.NEW_EMPLOYEE ? CONSTANTS.EMP_ID : CONSTANTS.JOB_ID}
          onChange={(item: any, e: any) => onClickGrowthEmployeeId(e, item, reason)}
          onBlur={() => OnBlurOfFields(reason)}
          value={reason.jobIdOrEmpId}
          disabled={!isRequiredEmpJob(reason)}
          className={( isRequiredEmpJob(reason) && reason.jobIdOrEmpIdError) ? 'controlValidation' : ''}
         data-attribute="Growth_Default_Input" />
        {(isRequiredEmpJob(reason) && reason.jobIdOrEmpIdError) ? <p className='validMessage'>{reason.jobIdOrEmpIdError}</p> : null}
        
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className={`mb-3 ${requestType == CONSTANTS.NON_STANDARD_EQUIPMENT ? 'add-top-space':''}`}>
        <Label required data-attribute="Growth_Default_Label_3">{reason.newEmployeeBusiness === CONSTANTS.NEW_EMPLOYEE ? CONSTANTS.EMP_NAME : CONSTANTS.JOB_NAME}</Label>
        {!setEmployeeFieldDisable() && !reason.showNewEmployee && reason.newEmployeeBusiness === CONSTANTS.NEW_EMPLOYEE ?
        <p className={`employee-value ${requestType == CONSTANTS.MANAGEMENT_VEHICLE ? 'management-margin':'non-standard-margin'}`}>{reason?.jobOrEmpName}</p>
        :
        <>
        <InputField
          placeholder={reason.newEmployeeBusiness === CONSTANTS.NEW_EMPLOYEE ? CONSTANTS.EMP_NAME : CONSTANTS.JOB_NAME}
          name='employeeName'
          onChange={(item: any, e: any) => onClickGrowthEmployeeName(e, item, reason)}
          onBlur={() => OnBlurOfFields(reason)}
          value={reason.jobOrEmpName}
         // inputRef={(element: any) => props.plannedRef.current[11] = element}
          className={reason.jobOrEmpNameError ? 'controlValidation' : ''}
         data-attribute="Growth_employeeName_Input" />
        {reason.jobOrEmpNameError ? <p className='validMessage'>{reason.jobOrEmpNameError}</p> : null}
        </>
        }
      </Col>{reason.newEmployeeBusiness === CONSTANTS.NEW_BUSINESS &&
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label required data-attribute="Growth_Default_Label_4">Sales Amount</Label>
          <InputField
            placeholder='Sales Amount'
            name='salesAmount'
            prefix={"$"}
            onChange={(item: any, e: any) => onClickGrowthSalesAmount(e, item, reason)}
            value={reason?.salesAmount}
            onBlur={(event: any) => salesAmountFormat(event, reason)}
           // onKeyPress={(event: any) => { isNumber(event) }}
           // onKeyDown={(event: any) => { isNumber(event) }}
           // inputRef={(element: any) => props.plannedRef.current[12] = element}
            className={reason.salesAmountError ? 'controlValidation' : ''}
           data-attribute="Growth_salesAmount_Input" />
          {reason.salesAmountError ? <p className='validMessage'>{reason.salesAmountError}</p> : null}
        </Col>       
      }
      {
          requestType == CONSTANTS.PRODUCTION_VEHICLE || requestType == CONSTANTS.MANAGEMENT_VEHICLE ?
          <Col xs={12} sm={4} md={4} lg={4} className='mb-sm-3 mb-2'> 
          <div className={`quote-price-switch-toggle ${requestType == CONSTANTS.PRODUCTION_VEHICLE ? "prodQuotePrice" : ""}` }>
          <Label data-attribute="Growth_Default_Label_5">Quote Price</Label>       
          <SwitchToggle className='mt-sm-3' checked={reason?.showQuotePrice} onChange={(item: any, e: any) =>onChangeQuotePrice(e, item, reason)} data-attribute="Growth_Default_SwitchToggle" />
          </div>       
          </Col> : '' 
      }   
      </>      
    }
    { requestType !== CONSTANTS.PRODUCTION_VEHICLE && reason.newEmployeeBusiness === CONSTANTS.NEW_EMPLOYEE ? <Col xs={12} sm={6} md={6} lg={6} xl={5} className='mb-3'>
      <div className={`new-employee-block ${ requestType !== CONSTANTS.MANAGEMENT_VEHICLE && reason?.showNewEmployee ? 'add-margin' : ''}`}>
        <div className='switch-toggle-block'>
          <Label className='mt-1 me-2' data-attribute="Growth_Default_Label_6">New Employee</Label>
          <SwitchToggle checked={reason?.showNewEmployee} onChange={(e: any, item: any) =>onChangeNewEmployee(e, item, reason)} data-attribute="Growth_Default_SwitchToggle_2" />
        </div> 
        {!reason?.showNewEmployee ?    
          <PrimaryButton text='Get Employee Info' className='get-employee-info-btn' onClick={() => onClickValidateEmployeeInfo(requestType, reason)} data-attribute="Growth_Default_Button" />
        : null }
      </div>      
    </Col> :''}
    <Col xs={12} className='mb-3 comment-block'>
      <Label data-attribute="Growth_Default_Label_7">Comment</Label>
      <InputField
        placeholder='Comment'
        name='comment'
        onChange={(item: any, e: any) => onClickGrowthComments(e, item, reason)}
        onBlur={() => OnBlurOfFields(reason)}
        value={reason.comments}
        multiline={true}
        resizable={false}
        row={2}
       // inputRef={(element: any) => props.plannedRef.current[13] = element}
       data-attribute="Growth_comment_Input" />
      {reason.commentsError ? <p className='validMessage'>{reason.commentsError}</p> : null}
    </Col>
  </>)
}

export default Growth;
